import { ALL_CATEGORY, useMegaMenuStore } from '../stores/useMegaMenuStore';

export const useMegaMenuState = () => {
  const isOpen = useMegaMenuStore(state => state.isOpen);
  const setIsOpen = useMegaMenuStore(state => state.setIsOpen);
  const activeCategory = useMegaMenuStore(state => state.activeCategory);
  const setActiveCategory = useMegaMenuStore(state => state.setActiveCategory);

  const isAllCategory = activeCategory === ALL_CATEGORY;

  return {
    isOpen,
    setIsOpen,
    activeCategory,
    setActiveCategory,
    isAllCategory,
  };
};
